/* eslint-disable react/prop-types */
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';

import { ComponentMapper } from '../utils/mappers';

const BasicPageTemplate = ({ data }) => {
	return (
		<Layout>
			<SEO
				slug={data.pageData?.slug}
				title={data.pageData.seo?.title}
				description={data.pageData.seo?.description}
				keywords={data.pageData.seo?.keywords}
			/>
			{data.pageData?.content?.sections?.map((section) => (
				<ComponentMapper key={section.id} section={section} />
			))}
		</Layout>
	);
};

export default BasicPageTemplate;

export const query = graphql`
	query BasicPageTemplate($id: String) {
		pageData: contentfulComposePage(id: { eq: $id }) {
			...ComposePageFragment
			content {
				...BasicPageSectionsFragment
			}
		}
	}
`;
